export const variants = {
    ctf: 'ctf',
    sw: 'sw',
    ew: 'ew'
}
